import { isAnalyticResult } from '@/utils/types/result-types'
import { createSelector } from 'reselect'
import { categorized } from './results'

export const analyticResults = createSelector([categorized], (d) =>
  d.imageResults.filter(isAnalyticResult),
)
